import lodash from '@/composables/lodash'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      lodash
    }
  }
})
